import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip } from '@mui/material';
import { ResourceType, type InventoryResource } from '@repo/api-gw-sdk';
import { useRouter } from 'next/navigation';
import { ThreatIssueIcon } from '@/components/security/threatIcons';
import { ClickableText } from '@/components/shared/clickableText';
import { CellActionsWrapper } from '@/components/table/cellActionsWrapper';
import type { AppRow, AppTable } from '@/components/table/tanstackTable';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { hasThreatFindings } from '../../inventoryAlerts/alertsModel';
import { hasSecurityIssue } from '../../security/securityUtils';
interface ResourceNameCellProps {
  row: AppRow<InventoryResource>;
  table: AppTable<InventoryResource>;
  showThreatIndicator?: boolean;
}
export const ResourceNameCell = t0 => {
  const $ = _c(8);
  const {
    row,
    table,
    showThreatIndicator
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== row || $[2] !== table) {
    t1 = () => {
      if (row.original.resourceType === ResourceType.GoogleWorkspaceResource) {
        router.push(`/explorer/${encodeURIComponent(row.original.id)}`);
        return;
      }
      if (row.getIsSelected()) {
        table.resetRowSelection(true);
      } else {
        table.setRowSelection({
          [row.id]: true
        });
      }
    };
    $[0] = router;
    $[1] = row;
    $[2] = table;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== handleClick || $[5] !== row || $[6] !== showThreatIndicator) {
    t2 = <BasicResourceNameCell row={row} onClick={handleClick} showThreatIndicator={showThreatIndicator} />;
    $[4] = handleClick;
    $[5] = row;
    $[6] = showThreatIndicator;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};

// A table that shows threats in a column of their own turns the threat styling off here.
export const BasicResourceNameCell = t0 => {
  const $ = _c(17);
  const {
    row,
    onClick,
    showThreatIndicator: t1
  } = t0;
  const showThreatIndicator = t1 === undefined ? true : t1;
  const {
    InventoryStatusColumns
  } = useFeatureFlags();
  if (!row.original.resourceName) {
    return null;
  }
  let t2;
  if ($[0] !== InventoryStatusColumns || $[1] !== row.original) {
    t2 = InventoryStatusColumns ? hasThreatFindings(row.original) : hasSecurityIssue(row.original);
    $[0] = InventoryStatusColumns;
    $[1] = row.original;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasThreat = t2;
  if (!showThreatIndicator) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        position: "relative"
      };
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== onClick || $[5] !== row.original.resourceName) {
      t4 = <ClickableText data-testid="resource-name-cell" onClick={onClick} sx={t3}>{row.original.resourceName}</ClickableText>;
      $[4] = onClick;
      $[5] = row.original.resourceName;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== row.original.resourceName || $[8] !== t4) {
      t5 = <CellActionsWrapper textToCopy={row.original.resourceName}>{t4}</CellActionsWrapper>;
      $[7] = row.original.resourceName;
      $[8] = t4;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    return t5;
  }
  let t3;
  if ($[10] !== hasThreat || $[11] !== onClick || $[12] !== row.original.resourceName) {
    t3 = hasThreat ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Tooltip title="Threat findings in the latest snapshot."><Stack><ThreatIssueIcon /></Stack></Tooltip><ClickableText data-testid="resource-name-cell" baseColor="var(--mui-palette-error-main)" hoverColor="var(--mui-palette-error-light)" onClick={onClick}>{row.original.resourceName}</ClickableText></Stack> : <ClickableText data-testid="resource-name-cell" onClick={onClick} sx={{
      lineHeight: "24px",
      position: "relative"
    }}>{row.original.resourceName}</ClickableText>;
    $[10] = hasThreat;
    $[11] = onClick;
    $[12] = row.original.resourceName;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== row.original.resourceName || $[15] !== t3) {
    t4 = <CellActionsWrapper textToCopy={row.original.resourceName}>{t3}</CellActionsWrapper>;
    $[14] = row.original.resourceName;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};